<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save" :loading="btnLoading">保存</el-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="com" label-position="left" label-width="100px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="单位代号">
              <el-input v-model="com.comcode" :maxlength="20" show-word-limit :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="单位全称">
              <el-input v-model="com.comfullname" :maxlength="80" show-word-limit :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vggrid ref="xGrid" :list="list" tableheight="600" flexname="" :cols="cols"
              :showfooter="false" :showPage="false" :resizable="true"
              :needBlackRow="false" :needPopMenu="false" :canbeEdit="false">
      </vggrid>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: "comTypeForm",
    data () {
      return {
        com: this.$route.params.com,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80},
          { field: 'syscodename', fieldtype: 'C', title: '名称',calculExpr:''}
        ],
        btnLoading: false
      }
    },
    activated() {
      this.init()
      // this.getList()
    },
    created () {
    },
    watch: {
    },
    filters: {
    },
    components: {vggrid},
    methods: {
      async init() {
        this.com = this.$route.params.form
        this.list = []
      },
      // async getList() {
      //   this.list = await request({
      //     url: '/ywgl/com/getComTypesList',
      //     method: "get",
      //     params: {comid:this.com.comid}
      //   })
      // },
      async save () {
        let selectRecords = this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        console.log(selectRecords)
        let model = {
          comid: this.com.comid,
          userid: this.$store.getters.loginUser.userid,
          comtypes: selectRecords
        }
        let data = await request({
          url: '/ywgl/com/saveComTypes',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'comIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
